/* eslint-disable eqeqeq */
import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/styles";
import { Button, TextField, CircularProgress } from "@material-ui/core";
import NavBar from "../../../components/NavBar/NavBar";
import OrderTabV2 from "./Chunks/OrderTab";
import SalesTabV2 from "./Chunks/SalesTab";
import CustomBottomBar from "../../../components/BottomBar/CustomBottomBar";
import ChangeStatus from "./Chunks/ChangeStatus";
import ImageViewDialogV2 from "./Chunks/ImageViewDialog";
import CaptureImageViewDialog from "./Chunks/CaptureImageViewDialog";
import { IsEmpty } from "../../../utils/helper";
import DispatchShippingLabelPrintViewV3 from "./Chunks/DispatchShippingLabelPrintViewV3";
import {
  HttpRequest,
  HttpRequestFileDownload,
} from "../../../utils/httpRequests";
import LoginMenu from "../../../components/LoginMenu/LoginMenu";
import CustomizedSnackbar from "../../../components/CustomizedSnackbar/CustomizedSnackbar";
import SelfDeliveryPrintLabelPdfView from "./Chunks/SelfDeliveryPrintLabelPdfView";
import TCSPdfLabelPrintView from "./Chunks/TCSPrintLabelPdfView";
import MnpPrintLabelPdfView from "./Chunks/MnpPrintLabelPdfView";
import DispatchSalesInvoice from "./Chunks/SalesInvoice";

const useStyles = (theme) => ({
  icon: {
    marginRight: theme.spacing(1),
  },
  heroContent: {
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(2, 0, 2),
  },
  heroButtons: {
    marginTop: theme.spacing(4),
  },
  cardGrid: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  card: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
  },
  cardMedia: {
    paddingTop: "56.25%", // 16:9
  },
  cardContent: {
    flexGrow: 1,
    overflow: "auto",
  },
  cardContentDiv: {
    display: "flex",
    justifyContent: "space-between",
  },
  footer: {
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(6),
  },
  tabsContainer: {
    width: "18%",
    // display: "flex",
    // justifyContent: "space-between",
    // marginTop: 70,
    // marginBottom: 10,
    // overFlow: "hidden",
    marginTop: 70,
    float: "left",
    marginLeft: 10,
    marginRight: 10,
  },
  tabsContentContainer: {
    width: "79%",

    // display: "flex",
    justifyContent: "space-between",
    marginTop: 70,
    float: "right",
    // overFlow: "hidden",
  },
  contentContainer: {
    alignItems: "center",
    textAlign: "center",
    width: "100%",
    marginLeft: 10,
    marginRight: 5,
  },
  contentContainerSM: {
    alignItems: "center",
    textAlign: "center",
    width: "100%",
    marginLeft: 10,
    marginRight: 5,
  },
  contentItemsContainerSM: {
    alignItems: "center",
    textAlign: "center",
    width: "100%",
    marginLeft: 10,
    marginRight: 5,
    float: "right",
  },
});

class C09DispatchDashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ordersData: [],
      ordersDataLoading: false,

      dispatchOrders: [],
      qaOrders: [],

      salesData: [],
      salesDataLoading: false,
      imagesData: [],
      imagesDataLoading: false,
      barcodeData: [{}],
      barcodeDataLoading: false,
      selectedOrder: {},
      selectedSalesData: {},

      isDownloadImages: false,
      isDownloadPdfImages: false,

      isLoading: false,
      isReload: true,

      openChangeStatusDialog: false,
      openShippingLabelDialog: false,
      openShippingInvoiceDialog: false,
      openShippingLabelWeightDialog: false,
      openSelfShippingLabelDialog: false,

      selectionData: [],
      selectionDataError: "",

      statusData: [],
      statusDataLoading: false,

      status: "",
      statusError: "",

      deliveryPartnerData: [],
      deliveryPartnerDataLoading: false,

      deliveryPartner: "",
      deliveryPartnerError: "",

      deliveryPersonsData: [],
      deliveryPersonsDataLoading: false,

      deliveryPersons: "",
      deliveryPersonsError: "",

      isDeliveryPartnerAttached: 0,

      remarks: "",
      remarksError: "",

      filterStatus: 0,
      filterStatusError: "",

      selectImageObject: {},
      selectImageIndex: 0,
      isOpenImageViewer: false,

      isNextArrowDisabled: true,
      isBackArrowDisabled: true,

      isOpenSnackbar: false,
      snackbarMessage: "",
      snackbarSeverity: "",

      itemBarCode: "",
      itemBarCodeDisabled: true,
      lastItemBarCode: "",

      isPrintShippingEnabled: 0,
      isPrintShippingInvoiceEnable: 0,
      isPrintShippingInvoicePrinted: 0,
      isTotalItemsBarCodeScanned: false,

      scannedOrderId: 0,

      deliveryCheckingLoading: false,

      boqData: [
        {
          id: 1,
          itemLabel: "Premium Hard Page",
          requiredLabel: "30",
          required: 30,
          availableLabel: "1000",
          available: 1000,
        },
        {
          id: 2,
          itemLabel: "Linen Red Color",
          requiredLabel: "50 in",
          required: 50,
          availableLabel: "100 in",
          available: 100,
        },
        {
          id: 3,
          itemLabel: "Card Board",
          requiredLabel: "70 in",
          required: 70,
          availableLabel: "50 in",
          available: 50,
        },
        {
          id: 4,
          itemLabel: "Laymination",
          requiredLabel: "40 in",
          required: 40,
          availableLabel: "150 in",
          available: 150,
        },
      ],
      Id: "",
      userPassword: "",
      isOpenCaptureImageViewer: false,
      dispatchedImg: "",
      openPrintDialog: false,
      openSelfPrintDialog: false,
      openTcsPrintDialog: false,
      openMnpPrintDialog: false,
      summaryPdfFile: "",
      consignmentNumber: "",
      orderWeightInKg: "",
      selfDeliveryCharges: "",
      isAuthFieldActive: false,
    };
  }

  handleChangePdfClose = () => {
    this.setState({
      openTcsPrintDialog: false,
      openMnpPrintDialog: false,
      openPrintDialog: false,
      openSelfPrintDialog: false,
    });
  };

  // handleChangeViewerToggle = (summaryPdfFile) => {
  //   console.log("summaryPdfFile ===>> " + summaryPdfFile);
  //   const value = this.state.openPrintDialog ? false : true;
  //   this.setState({
  //     openPrintDialog: value,
  //     summaryPdfFile: summaryPdfFile,
  //   });
  // };

  componentDidMount() {
    this.getOrdersData();
    this.getData(
      `/sales/C09SalesOrderDeliveryPartnersView`,
      "deliveryPartnerData",
      "deliveryPartnerDataLoading"
    );
    this.getData(
      `/sales/C09CommonDeliveryPersonsView`,
      "deliveryPersonsData",
      "deliveryPersonsDataLoading"
    );
  }

  handleSnackbar = (isOpen, message, severity) => {
    this.setState({
      isOpenSnackbar: isOpen,
      snackbarMessage: message,
      snackbarSeverity: severity,
    });
  };

  getData = async (endpoint = "", stateName = "", loadingStateName = "") => {
    let resData = [];
    this.setState({
      [loadingStateName]: true,
    });
    const res = await HttpRequest(
      "GET",
      `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}${endpoint}`,
      null,
      "authorizeJson"
    );
    if (res.isSuccess) {
      resData = res.data || [];
    } else {
      if (res.statusCode === 401) {
        this.setState({
          isLoginMenu: true,
        });
      } else {
        this.handleSnackbar(true, `${res.message}`, "error");
      }
    }

    switch (stateName) {
      case "salesData":
        this.setState(
          {
            isPrintShippingEnabled: resData[0].isPrintShippingEnabled || 0,
            isPrintShippingInvoiceEnable:
              resData[0].isPrintShippingInvoiceEnable || 0,
            isPrintShippingInvoicePrinted:
              resData[0].isPrintShippingInvoicePrinted || 0,
            orderWeightInKg: resData[0].orderWeight || "",
            selfDeliveryCharges: resData[0].deliveryCharges || "0",
            deliveryPartner: resData[0].orderDeliveryPartnerId,
            deliveryPartnerError: "",
            deliveryPersons: resData[0].deliveryPersonsId,
            deliveryPersonsError: "",
            isDeliveryPartnerAttached:
              resData[0].isDeliveryPartnerAttached || 0,
            [stateName]: resData[0],
            [loadingStateName]: false,
          },
          () => {
            if (
              this.state.deliveryPartner &&
              this.state.deliveryPartner != 3 &&
              this.state.isDeliveryPartnerAttached == 0
            )
              this.checkDeliveryExists(null, this.state.deliveryPartner);
          }
        );

        break;
      case "ordersData":
        this.setState({
          selectedOrder: {},
          imagesData: [],
          selectedSalesData: {},
          salesData: [],
          qaOrders: resData && resData.length > 0 ? resData[0].qaOrders : [],
          dispatchOrders:
            resData && resData.length > 0 ? resData[0].dispatchOrders : [],
          [stateName]: resData,
          [loadingStateName]: false,
        });

        break;
      case "barcodeData":
        if (res.isSuccess && resData.length > 0) {
          let isAllItemsBarcodesScanned = false;
          let AllNumbers = this.state.selectedOrder.totalNumberOfBarCodes;
          let barcodeData = [...this.state.barcodeData];

          if (!IsEmpty(this.state.barcodeData)) {
            const bacrCodeobj = barcodeData.find(
              (x) => x.orderId === resData[0].orderId
            );
            if (!IsEmpty(bacrCodeobj)) {
              const barCodeOFProductobj = barcodeData.find(
                (x) =>
                  x.orderId === resData[0].orderId &&
                  x &&
                  x.productId === resData[0].productId
              );
              if (IsEmpty(barCodeOFProductobj)) {
                barcodeData.push(resData[0]);
                if (barcodeData.length == AllNumbers) {
                  isAllItemsBarcodesScanned = true;
                }

                this.setState({
                  barcodeData: barcodeData,
                  isTotalItemsBarCodeScanned: isAllItemsBarcodesScanned,
                });
              }
            } else {
              let barcodeData = [];
              barcodeData.push(resData[0]);
              if (barcodeData.length == AllNumbers) {
                isAllItemsBarcodesScanned = true;
              }
              this.setState({
                barcodeData: barcodeData,
                isTotalItemsBarCodeScanned: isAllItemsBarcodesScanned,
              });
            }
          } else {
            let barcodeData = [];
            barcodeData.push(resData[0]);
            if (barcodeData.length == AllNumbers) {
              isAllItemsBarcodesScanned = true;
            }
            this.setState({
              barcodeData: barcodeData,
              isTotalItemsBarCodeScanned: isAllItemsBarcodesScanned,
            });
          }
          localStorage.setItem("ckBarcodeData", JSON.stringify(resData[0]));
          window.open("#/print-barcode");
        }

        if (stateName != "barcodeData") {
          this.setState({
            [stateName]: resData,
            [loadingStateName]: false,
          });
        } else {
          this.setState({
            isPrintShippingEnabled: resData.isPrintShippingEnabled,
            [loadingStateName]: false,
          });
        }

        break;
      default:
        this.setState({
          [stateName]: resData,
          [loadingStateName]: false,
        });
        break;
    }
  };

  getSalesOrderShippingLabelData = async (
    orderId,
    orderWeightInKg,
    deliveryPartner,
    deliveryPersons,
    selfDeliveryCharges
  ) => {
    let resData = [];
    this.setState({
      isLoading: true,
    });
    const res = await HttpRequest(
      "GET",
      `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/sales/C09SalesOrderViewByIdForShippingLabel?orderId=${orderId}&orderWeight=${orderWeightInKg}&deliveryPartnerId=${deliveryPartner}&deliveryPersonId=${deliveryPersons}&deliveryCharges=${selfDeliveryCharges}`,
      null,
      "authorizeJson"
    );
    if (res.isSuccess) {
      this.setState({
        isLoading: false,
      });
      resData = res.data || [];
      if (resData.length > 0) {
        if (resData[0].isFileExists == 1) {
          if (this.state.deliveryPartner == 2) {
            this.setState({
              summaryPdfFile: resData[0].fileName,
              consignmentNumber: resData[0].consignmentNumber,
              openTcsPrintDialog: true,
            });
          } else if (this.state.deliveryPartner == 4) {
            this.setState({
              openMnpPrintDialog: true,
              consignmentNumber: resData[0].consignmentNumber,
              summaryPdfFile: null,
            });
          } else {
            this.setState({
              summaryPdfFile: resData[0].fileName,
              consignmentNumber: resData[0].consignmentNumber,
              openSelfPrintDialog: true,
            });
          }
        } else {
          // this.setState({
          //   openSelfShippingLabelDialog: true,
          // });

          this.handleSnackbar(
            true,
            "Unable to get shipping found from server",
            "error"
          );
        }
      }
    } else {
      this.setState({
        isLoading: false,
      });
      this.handleSnackbar(true, res.message, "error");
    }
  };



  cancelSalesOrderShipping = async (
    orderId
  ) => {
    let resData = [];
    this.setState({
      isLoading: true,
    });
    const res = await HttpRequest(
      "POST",
      `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/sales/C09SalesOrderDeliveryBookingCancel?orderId=${orderId}`,
      null,
      "authorizeJson"
    );
    if (res.isSuccess) {
      this.setState({
        isLoading: false,
      });
      this.handleSnackbar(
        true,
        "Delivery partner booking cancelled",
        "success"
      );
    } else {
      this.setState({
        isLoading: false,
      });
      this.handleSnackbar(true, res.message, "error");
    }
  };



  getOrdersData = async (status = "") => {
    const statusValue = status !== "" ? status : this.state.filterStatus;
    this.getData(
      `/sales/C09SalesOrderView?statusId=${statusValue}`,
      "ordersData",
      "ordersDataLoading"
    );
  };

  getSalesData = async (orderId) => {
    this.getData(
      `/sales/C09SalesOrderItemsView?orderId=${orderId}`,
      "salesData",
      "salesDataLoading"
    );
  };

  getImagesData = async (orderId, itemId) => {
    this.getData(
      `/sales/C09SalesOrderItemsImagesView?orderId=${orderId}&productId=${itemId}`,
      "imagesData",
      "imagesDataLoading"
    );
  };

  printBarcode = async () => {
    this.getData(
      `/sales/C09SalesOrderItemsImagesBarcodeView?orderId=${this.state.selectedOrder.orderId}&productId=${this.state.selectedSalesData.productId}`,
      "barcodeData",
      "barcodeDataLoading"
    );
  };

  toggleChangeStatusDialog = (data) => {
    const { openChangeStatusDialog } = this.state;
    this.setState({
      openChangeStatusDialog: !openChangeStatusDialog,
      selectedData: data,
    });
  };

  toggleShippingWeightLabelDialog = () => {
    const { openShippingLabelWeightDialog } = this.state;
    this.setState({
      openShippingLabelWeightDialog: !openShippingLabelWeightDialog,
    });
  };

  isDeliveryDialogValid = () => {

    let isValid = true;
    if (!this.state.deliveryPartner) {
      isValid = false;
      this.handleSnackbar(true, "Please select delivery partner.", "error");
    } else if (!this.state.orderWeightInKg) {
      isValid = false;
      this.handleSnackbar(true, "Please enter oder weight", "error");
    } else if (this.state.deliveryPartner && !(this.state.orderWeightInKg && this.state.orderWeightInKg > 0)) {
      this.handleSnackbar(true, "Weight can't be 0 or negative", "error");
      isValid = false;
    } else if (
      this.state.deliveryPartner == 3 && !this.state.deliveryPersons) {
      isValid = false;
      this.handleSnackbar(
        true,
        "Delivery person should be selected.",
        "error"
      );
    } else if (
      this.state.deliveryPartner == 3 &&
      !(this.state.selfDeliveryCharges && this.state.selfDeliveryCharges >= 0)
    ) {
      isValid = false;
      this.handleSnackbar(
        true,
        "Please enter valid delivery charges",
        "error"
      );
    }
    return isValid;
  };

  toggleShippingWeightLabelCloseDialog = (actionTypeId) => {
    if (actionTypeId == 1 && !this.isDeliveryDialogValid()) {
      return;
    }

    const { openShippingLabelWeightDialog } = this.state;
    this.setState({
      openShippingLabelWeightDialog: !openShippingLabelWeightDialog,
    });


    if (actionTypeId == 1) {
      this.setState({
        isDeliveryPartnerAttached: 1,
      });


      // this.handleChangeViewerToggle(this.state.orderWeightInKg);
      this.getSalesOrderShippingLabelData(
        this.state.selectedOrder.orderId,
        this.state.orderWeightInKg,
        this.state.deliveryPartner,
        !this.state.deliveryPersons ? 0 : this.state.deliveryPersons,
        this.state.selfDeliveryCharges

      );
    }

    if (actionTypeId == 2) {
      this.setState({
        isDeliveryPartnerAttached: 0,
      });
      // this.handleChangeViewerToggle(this.state.orderWeightInKg);
      this.cancelSalesOrderShipping(
        this.state.selectedOrder.orderId,
        this.state.orderWeightInKg,
        this.state.deliveryPartner,
        this.state.deliveryPersons,
        this.state.selfDeliveryCharges
      );
    }

  };

  // eslint-disable-next-line no-unused-vars
  toggleSelfShippingWeightLabelCloseDialog = (actionTypeId) => {
    const { openSelfShippingLabelDialog } = this.state;
    this.setState({
      openSelfShippingLabelDialog: !openSelfShippingLabelDialog,
    });
  };

  handleCloseShippingInvoiceDialog = () => {
    const { openShippingInvoiceDialog } = this.state;
    this.setState({
      openShippingInvoiceDialog: !openShippingInvoiceDialog,
    });
  };

  handleCloseShippingInvoiceDialog = () => {
    const { openShippingInvoiceDialog } = this.state;
    this.setState({
      openShippingInvoiceDialog: !openShippingInvoiceDialog,
    });
  };

  toggleShippingInvoiceDialog = () => {
    const { openShippingInvoiceDialog } = this.state;
    this.setState({
      openShippingInvoiceDialog: !openShippingInvoiceDialog,
    });
  };

  onCheckClick = (e, row = {}) => {
    const { checked } = e.target;
    let { ordersData } = this.state;
    const studentIndex = ordersData.findIndex(
      (item) => item.orderId === row.orderId
    );
    ordersData[studentIndex].isChecked = checked;
    this.setState({
      ordersData,
      selectionDataError: "",
    });
  };

  getOrderId = (order) => {
    this.getSalesData(order.orderId);

    this.setState({
      selectedOrder: order,
      imagesData: [],
      selectedSalesData: {},
      lastItemBarCode: "",
    });
  };

  getImagesAgainstOrderIdAndItemId = (sale, orderId, itemId) => {
    this.getImagesData(orderId, itemId);
    this.setState({
      selectedSalesData: sale,
    });
  };

  onFocusOutItemBarCodeField = () => {
    // alert(this.state.itemBarCode);
    if (!IsEmpty(this.state.itemBarCode)) {
      this.onScanItem();
    }
  };

  onScanItem = async () => {
    let resData = [];

    const itemAssignedItemBarCode = IsEmpty(this.state.itemBarCode)
      ? ""
      : this.state.itemBarCode;

    var previousIds = [];

    if (this.state.salesData.items) {
      this.state.salesData.items.forEach((sales) => {
        previousIds.push(sales.id);
      });
    }

    const data = new FormData();

    data.append("itemBarCode", itemAssignedItemBarCode);
    const loadingName = "onScanItemBarCodeLoading";
    const endpoint = `/sales/C09SalesOrderItemsView?orderId=${this.state.selectedOrder.orderId}&barcode=${itemAssignedItemBarCode}&previousIds=${previousIds}`;
    const res = await HttpRequest(
      "GET",
      `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}${endpoint}`,
      null,
      "authorizeJson"
    );

    if (res.isSuccess) {
      resData = res.data || [];
      if (!IsEmpty(resData)) {
        this.setState({
          salesData: resData[0],
          isPrintShippingEnabled: resData[0].isPrintShippingEnabled,
          isPrintShippingInvoiceEnable: resData[0].isPrintShippingInvoiceEnable,
          isPrintShippingInvoicePrinted:
            resData[0].isPrintShippingInvoicePrinted,
        });
      }
    } else {
      if (res.statusCode === 401) {
        this.setState({
          isLoginMenu: true,
          isReload: false,
        });
      } else {
        this.handleSnackbar(true, res.message, "error");
      }
    }
    this.setState({
      [loadingName]: false,
      itemBarCode: "",
      lastItemBarCode: itemAssignedItemBarCode,
    });
  };

  checkDeliveryExists = async (e, deliveryPartnerId) => {
    if (!IsEmpty(e)) {
      e.preventDefault();
    }

    this.setState({
      deliveryCheckingLoading: true,
    });
    let deliveryErrorMsg = "";
    let isExists = false;
    const endpoint = `/sales/C09SalesOrderShippingLabelDeliveryCheck?destinationCityId=${this.state.selectedOrder.destinationCityId}&deliveryPartnerId=${deliveryPartnerId}`;
    const res = await HttpRequest(
      "GET",
      `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}${endpoint}`,
      null,
      "authorizeJson"
    );
    if (res.isSuccess) {
      let resData = res.data || [];
      if (!IsEmpty(resData)) {
        isExists = resData[0]["isDeliveryExists"];
        if (!isExists) {
          deliveryErrorMsg = "Delivery partner doesn't cover this address";
        }
      }
    }

    if (!isExists && deliveryErrorMsg == "") {
      deliveryErrorMsg = "Unable to check delivery status.";
    }

    this.setState({
      deliveryCheckingLoading: false,
      deliveryPartnerError: deliveryErrorMsg,
    });
    return isExists;
  };

  onHandleChange = (e) => {
    const { name, value } = e.target;
    const errName = `${name}Error`;
    switch (name) {
      case "filterStatus":
        this.getOrdersData(value);
        break;
      case "deliveryPartner":
        this.setState(
          {
            selfDeliveryCharges: "",
            deliveryErrorMsg: "",
          },
          () => {
            if (value && value != 3) this.checkDeliveryExists(e, value);
          }
        );

        break;
      default:
        break;
    }
    this.setState({
      [name]: value,
      [errName]: "",
      selectionDataError: "",
    });
  };

  onDispatchedCapturedImgChange = (sale, value) => {
    this.setState({
      dispatchedImg: value,
      selectedSalesData: sale,
    });
    this.updateDispatchImage(value);
  };

  updateDispatchImage = async (value) => {
    const url = `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/sales/C09SalesOrderItemsDispatchImageSave?orderId=${this.state.selectedOrder.orderId}`;
    const data = new FormData();
    data.append("orderItemId", this.state.selectedSalesData.id);
    data.append("disptachedImg", value);
    let result = await HttpRequest("POST", url, data, "authorize");

    if (result.isSuccess) {
      this.handleCloseCaptureImageDialog();
      this.getSalesData(this.state.selectedOrder.orderId);
      this.handleSnackbar(true, "Success", "success");
    } else {
      this.handleCloseCaptureImageDialog();
      this.handleSnackbar(true, "Error", "error");
    }
  };

  ValidateCredentials = () => {
    let isValidated = true;
    let userName = this.state.Id;
    let userPassword = this.state.userPassword;
    if (userName == "") {
      this.handleSnackbar(true, "Please Enter User ID.", "error");
      isValidated = false;
    }

    if (userPassword == "") {
      this.handleSnackbar(true, "Please Enter User Password.", "error");
      isValidated = false;
    }

    if (isValidated) {
      this.scanBarCodeWithUserCredientials(userName, userPassword);
    }
  };

  isFormValid = () => {
    let { deliveryPartnerError } = this.state;
    let isValid = true;

    if (!this.state.deliveryPartner) {
      isValid = false;
      deliveryPartnerError = "Please select delivery partner";
    } else {
      deliveryPartnerError = "";
    }

    this.setState({
      deliveryPartnerError,
    });

    return isValid;
  };

  onSaveClick = () => {
    // if (this.isFormValid()) {
    document.getElementById("btnStatusSubmit").click();
    // }
  };

  onFormSubmit = async (e) => {
    e.preventDefault();
    this.setState({
      isLoading: true,
    });
    const data = new FormData(e.target);
    const res = await HttpRequest(
      "POST",
      `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/sales/C09SalesOrderStatusSave`,
      data,
      "authorize"
    );

    if (res.isSuccess) {
      this.handleSnackbar(true, "Saved", "success");
      this.getData(
        `/sales/C09SalesOrderView?statusId=${this.state.filterStatus}`,
        "ordersData",
        ""
      );
      this.toggleChangeStatusDialog();
      this.setState({
        status: "",
        statusError: "",
        remarks: "",
        remarksError: "",
      });
    } else {
      if (res.statusCode === 401) {
        this.setState({
          isLoginMenu: true,
          isReload: false,
        });
      } else {
        this.handleSnackbar(true, res.message, "error");
      }
    }
    this.setState({
      isLoading: false,
    });
  };

  handleOnKeyPressedForImageDilog = (event) => {
    switch (event.key) {
      case "ArrowRight":
        if (!this.state.isNextArrowDisabled) {
          this.onNextArrowClick();
        }
        break;
      case "ArrowLeft":
        if (!this.state.isBackArrowDisabled) {
          this.onBackArrowClick();
        }
        break;
      default:
        break;
    }
  };

  onImageClick = (object) => {
    let { imagesData, isNextArrowDisabled, isBackArrowDisabled } = this.state;
    const currentImageIndex = imagesData.findIndex(
      (item) => item.id == object.id
    );

    if (currentImageIndex != -1) {
      if (currentImageIndex == 0) {
        isBackArrowDisabled = true;
      } else {
        isBackArrowDisabled = false;
      }
      if (currentImageIndex + 1 == imagesData.length) {
        isNextArrowDisabled = true;
      } else {
        isNextArrowDisabled = false;
      }
    }

    window.addEventListener(
      "keydown",
      this.handleOnKeyPressedForImageDilog,
      false
    );

    this.setState({
      selectImageObject: object,
      isOpenImageViewer: true,
      selectImageIndex: currentImageIndex,
      isNextArrowDisabled,
      isBackArrowDisabled,
    });
  };

  handleImageViewerToggle = () => {
    const value = this.state.isOpenImageViewer ? false : true;
    this.setState({
      isOpenImageViewer: value,
    });
  };

  handleCloseImageDialog = () => {
    window.removeEventListener("keydown", this.handleOnKeyPressedForImageDilog);
    this.setState({
      isOpenImageViewer: false,
      selectImageIndex: 0,
      selectImageObject: {},
      isBackArrowDisabled: true,
      isNextArrowDisabled: true,
    });
  };

  handleCaptureImageViewerToggle = (sale) => {
    const value = this.state.isOpenCaptureImageViewer ? false : true;
    this.setState({
      isOpenCaptureImageViewer: value,
      selectedSalesData: sale,
    });
  };

  handleCloseCaptureImageDialog = () => {
    const value = this.state.isOpenCaptureImageViewer ? false : true;
    this.setState({
      isOpenCaptureImageViewer: value,
    });
  };

  handleQACheckList = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const { checked, name, value } = e.target;
    const isChecked = checked ? 1 : 0;
    let { salesData } = this.state;
    let saleIndex = salesData.findIndex((item) => item.id == name);
    if (saleIndex != -1) {
      let activitiesList = salesData[saleIndex]["qaActivitiesList"] || [];
      const checkboxIndex = activitiesList.findIndex(
        (item) => item.id == value
      );

      if (checkboxIndex != -1) {
        activitiesList[checkboxIndex]["isChecked"] = isChecked;
        salesData[saleIndex]["qaActivitiesList"] = activitiesList;
        this.setState({
          salesData,
        });
      }
    }
  };

  downloadFile = async (e, fileName) => {
    e.preventDefault();

    const url = `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/albums/C01ImageView?fileName=${fileName}`;

    let result = await HttpRequestFileDownload(
      "GET",
      url,
      "authorizeJson",
      fileName
    );

    if (result.isSuccess) {
      let csvURL = URL.createObjectURL(result.data);
      var tempLink = document.createElement("a");
      tempLink.href = csvURL;
      tempLink.setAttribute("download", fileName);
      tempLink.click();
    } else {
      if (result.statusCode === 401) {
        this.setState({
          isLoginMenu: true,
          isReload: false,
        });
      } else {
        alert(result.message);
      }
    }
  };

  handleCloseShippingLabelDialog = async () => {
    const { openShippingLabelDialog } = this.state;
    this.setState({
      openShippingLabelDialog: !openShippingLabelDialog,
    });
  };

  handleShippingLabelPrintClick = async (e, isPdfRemainOpen = false) => {
    const url = `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/sales/C09SalesOrderIsPrintShippingLabelPrinted?orderId=${this.state.selectedOrder.orderId}`;

    const data = new FormData();

    let result = await HttpRequest("POST", url, data, "authorize");

    if (result.isSuccess) {
      if (!isPdfRemainOpen) {
        this.handleChangePdfClose();
      }
      this.getSalesData(this.state.selectedOrder.orderId);
      this.handleSnackbar(true, "Success", "Printed");
    } else {
      this.handleSnackbar(true, "Error", "error");
    }
  };

  handleCloseShippingInvoiceDialog = () => {
    const { openShippingInvoiceDialog } = this.state;
    this.setState({
      openShippingInvoiceDialog: !openShippingInvoiceDialog,
    });
  };

  handleShippingInvoicePrintClick = async () => {
    const url = `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/sales/C09SalesOrderIsPrintShippingInvoicePrinted?orderId=${this.state.selectedOrder.orderId}`;

    const data = new FormData();

    let result = await HttpRequest("POST", url, data, "authorize");

    if (result.isSuccess) {
      const { openShippingInvoiceDialog } = this.state;
      this.setState({
        openShippingInvoiceDialog: !openShippingInvoiceDialog,
      });
      this.getSalesData(this.state.selectedOrder.orderId);
      this.handleSnackbar(true, "Success", "success");
    } else {
      const { openShippingInvoiceDialog } = this.state;
      this.setState({
        openShippingInvoiceDialog: !openShippingInvoiceDialog,
      });
      this.handleSnackbar(true, "Error", "error");
    }
  };

  handleChangeStatusClose = () => {
    this.toggleChangeStatusDialog();
    this.setState({
      deliveryPartner: "",
      deliveryPartnerError: "",
      remarks: "",
      remarksError: "",
    });
  };

  onNextArrowClick = () => {
    let {
      imagesData,
      isNextArrowDisabled,
      isBackArrowDisabled,
      selectImageIndex,
      selectImageObject,
    } = this.state;
    let imageObject = selectImageObject;
    let prevImageIndex = selectImageIndex;
    let nextImageIndex = selectImageIndex;

    if (prevImageIndex != -1) {
      nextImageIndex = prevImageIndex + 1;
      if (nextImageIndex == imagesData.length) {
        isNextArrowDisabled = true;
      } else {
        if (nextImageIndex + 1 == imagesData.length) {
          isNextArrowDisabled = true;
        } else {
          isNextArrowDisabled = false;
        }
        isBackArrowDisabled = false;
        imageObject = imagesData[nextImageIndex] || {};
      }
    }

    this.setState({
      selectImageObject: imageObject,
      selectImageIndex: nextImageIndex,
      isNextArrowDisabled,
      isBackArrowDisabled,
    });
  };

  onBackArrowClick = () => {
    let {
      imagesData,
      isNextArrowDisabled,
      isBackArrowDisabled,
      selectImageIndex,
      selectImageObject,
    } = this.state;
    let imageObject = selectImageObject;
    let prevImageIndex = selectImageIndex;
    let newImageIndex = selectImageIndex;

    if (prevImageIndex != -1 || prevImageIndex != 0) {
      newImageIndex = prevImageIndex - 1;

      if (newImageIndex == 0) {
        isBackArrowDisabled = true;
      } else {
        isBackArrowDisabled = false;
      }
      isNextArrowDisabled = false;
      imageObject = imagesData[newImageIndex] || {};
    }

    this.setState({
      selectImageObject: imageObject,
      selectImageIndex: newImageIndex,
      isNextArrowDisabled,
      isBackArrowDisabled,
    });
  };

  scanBarCodeWithUserCredientials = async (Id, userPassword) => {
    let resData = [];
    var previousIds = [];

    if (this.state.salesData.items) {
      this.state.salesData.items.forEach((sales) => {
        previousIds.push(sales.id);
      });
    }
    const loadingName = "onScanItemBarCodeLoading";
    const endpoint = `/sales/C09SalesOrderItemsWithUserCredentialsView?orderId=${this.state.selectedOrder.orderId}&previousIds=${previousIds}&Id=${Id}&userPassword=${userPassword}`;
    // console.log(endpoint);
    const res = await HttpRequest(
      "POST",
      `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}${endpoint}`,
      null,
      "authorizeJson"
    );

    if (res.isSuccess) {
      resData = res.data || [];
      if (!IsEmpty(resData)) {
        this.setState({
          userName: "",
          userPassword: "",
          salesData: resData[0],
          isPrintShippingEnabled: resData[0].isPrintShippingEnabled,
          isPrintShippingInvoiceEnable: resData[0].isPrintShippingInvoiceEnable,
          isPrintShippingInvoicePrinted:
            resData[0].isPrintShippingInvoicePrinted,
        });
      }
    } else {
      if (res.statusCode === 401) {
        this.setState({
          isLoginMenu: true,
          isReload: false,
        });
      } else {
        this.handleSnackbar(true, res.message, "error");
      }
    }
    this.setState({
      [loadingName]: false,
    });
  };

  render() {
    const { classes } = this.props;
    return (
      <Fragment>
        <NavBar isAuthorize title="Dispatch Dashboard" />
        <LoginMenu
          reload={this.state.isReload}
          open={this.state.isLoginMenu}
          handleClose={() => this.setState({ isLoginMenu: false })}
        />
        <form onSubmit={this.onFormSubmit}>
          <input
            name="deliveryPartnerId"
            value={this.state.deliveryPartner || ""}
            type="hidden"
          />
          <input
            name="orderId"
            value={this.state.selectedOrder.orderId || ""}
            type="hidden"
          />
          <input
            type="submit"
            style={{ display: "none" }}
            id="btnStatusSubmit"
          />
        </form>
        <ImageViewDialogV2
          downloadFile={(e, fileName) => this.downloadFile(e, fileName)}
          handleClose={() => this.handleCloseImageDialog()}
          open={this.state.isOpenImageViewer}
          data={this.state}
          onNextArrowClick={() => this.onNextArrowClick()}
          onBackArrowClick={() => this.onBackArrowClick()}
        />

        <CaptureImageViewDialog
          handleClose={() => this.handleCloseCaptureImageDialog()}
          open={this.state.isOpenCaptureImageViewer}
          data={this.state}
          onHandleChange={(sale, value) =>
            this.onDispatchedCapturedImgChange(sale, value)
          }
        />

        <ChangeStatus
          onSaveClick={() => this.onSaveClick()}
          onHandleChange={this.onHandleChange}
          open={this.state.openChangeStatusDialog}
          state={this.state}
          handleClose={() => this.handleChangeStatusClose()}
          onCheckClick={(e, row) => this.onCheckClick(e, row)}
        />

        <div
          style={{
            minHeight: window.innerHeight - 120,
            maxHeight: window.innerHeight - 120,
          }}
          className={classes.tabsContainer}
        >
          <OrderTabV2
            onHandleChange={this.onHandleChange}
            values={this.state}
            getOrderId={(id) => this.getOrderId(id)}
          />
        </div>
        <div className={classes.tabsContentContainer}>
          <div
            style={{
              minHeight: window.innerHeight - 120,
              maxHeight: window.innerHeight - 120,
            }}
            className={classes.contentItemsContainerSM}
          >
            <SalesTabV2
              values={this.state}
              getImagesOrderIdAndProductId={(id, orderId, itemId) =>
                this.getImagesAgainstOrderIdAndItemId(id, orderId, itemId)
              }
              onHandleChange={this.onHandleChange}
              onFocusOutItemBarCodeField={this.onFocusOutItemBarCodeField}
              handleQACheckList={(e) => this.handleQACheckList(e)}
              onImageClick={(object) => this.onImageClick(object)}
              handleCaptureImageViewerToggle={(sale) =>
                this.handleCaptureImageViewerToggle(sale)
              }
            />
          </div>
        </div>

        <DispatchShippingLabelPrintViewV3
          open={this.state.openShippingLabelWeightDialog}
          handleClose={(actionTypeId) =>
            this.toggleShippingWeightLabelCloseDialog(actionTypeId)
          }
          orderId={this.state.selectedOrder.orderId}
          state={this.state}
          onHandleChange={(e) => this.onHandleChange(e)}
        />

        <TCSPdfLabelPrintView
          open={this.state.openTcsPrintDialog}
          handleClose={() => this.handleChangePdfClose()}
          handlePrint={() => this.handleShippingLabelPrintClick()}
          summaryPdfFile={this.state.summaryPdfFile}
        />

        <SelfDeliveryPrintLabelPdfView
          open={this.state.openSelfPrintDialog}
          handleClose={() => this.handleChangePdfClose()}
          handlePrint={() => this.handleShippingLabelPrintClick()}
          summaryPdfFile={this.state.summaryPdfFile}
        />

        <MnpPrintLabelPdfView
          open={this.state.openMnpPrintDialog}
          handleClose={() => this.handleChangePdfClose()}
          handlePrint={(e, pdfRemainOpen) =>
            this.handleShippingLabelPrintClick(e, pdfRemainOpen)
          }
          consignmentNumber={this.state.consignmentNumber}
        />

        <DispatchSalesInvoice
          open={this.state.openShippingInvoiceDialog}
          handleClose={() => this.handleCloseShippingInvoiceDialog()}
          handlePrint={() => this.handleShippingInvoicePrintClick()}
          orderId={this.state.selectedOrder.orderId}
        />

        <CustomBottomBar
          rightButtonHide
          leftButtonHide
          otherActions={
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                width: "77%",
              }}
            >
              <div>
                <Button
                  disabled={
                    IsEmpty(this.state.selectedOrder) ||
                    this.state.selectedOrder.statusId != 16 ||
                    this.state.isPrintShippingInvoiceEnable == 0

                    //  (!this.state.selectedOrder.totalNumberOfBarCodes===this.state.barcodeData.length)
                  }
                  onClick={() => this.toggleShippingInvoiceDialog()}
                  style={{
                    marginRight: 10,
                    textTransform: "capitalize",
                  }}
                  color="primary"
                  variant="contained"
                >
                  Print Shipping Invoice
                </Button>

                <Button
                  disabled={
                    IsEmpty(this.state.selectedOrder) ||
                    this.state.selectedOrder.statusId != 16 ||
                    this.state.isPrintShippingEnabled == 0

                    // this.state.isTotalItemsBarCodeScanned==false
                  }
                  // onClick={this.toggleShippingLabelDialog}
                  onClick={() => this.toggleShippingWeightLabelDialog()}
                  // onClick={this.handleChangeViewerToggle}
                  style={{
                    marginRight: 10,
                    textTransform: "capitalize",
                  }}
                  color="primary"
                  variant="contained"
                >
                  {this.state.isLoading ? (
                    <CircularProgress
                      size={23}
                      style={{ color: "white", fontWeight: 600 }}
                    />
                  ) : (
                    "Print Shipping Label"
                  )}
                </Button>
                <Button
                  disabled={
                    IsEmpty(this.state.selectedOrder) ||
                    this.state.selectedOrder.statusId != 16 ||
                    this.state.isPrintShippingInvoicePrinted == 0
                  }
                  onClick={() => this.toggleChangeStatusDialog()}
                  style={{
                    marginRight: 10,
                    textTransform: "capitalize",
                    background:
                      IsEmpty(this.state.selectedOrder) ||
                        this.state.selectedOrder.statusId != 16 ||
                        this.state.isPrintShippingInvoicePrinted == 0
                        ? "#b8ddb8"
                        : "green",
                    color: "white",
                  }}
                  variant="contained"
                >
                  Dispatch
                </Button>
              </div>

              <div>
                <Button
                  disabled={
                    IsEmpty(this.state.selectedOrder) ||
                    this.state.selectedOrder.statusId != 16
                  }
                  onClick={this.ValidateCredentials}
                  style={{
                    marginRight: 10,
                    textTransform: "capitalize",
                  }}
                  color="primary"
                  variant="contained"
                >
                  Override Scanning
                </Button>

                <TextField
                  size="small"
                  disabled={
                    IsEmpty(this.state.selectedOrder) ||
                    this.state.selectedOrder.statusId != 16
                  }
                  label="User ID"
                  variant="outlined"
                  name="Id"
                  style={{ marginRight: 10 }}
                  value={this.state.userName}
                  onChange={this.onHandleChange}
                  onFocus={() => this.setState({ isAuthFieldActive: true })}
                  onBlur={() => this.setState({ isAuthFieldActive: false })}
                />

                <TextField
                  size="small"
                  label="Password"
                  type="password"
                  variant="outlined"
                  name="userPassword"
                  disabled={
                    IsEmpty(this.state.selectedOrder) ||
                    this.state.selectedOrder.statusId != 16
                  }
                  value={this.state.userPassword}
                  onChange={this.onHandleChange}
                  onFocus={() => this.setState({ isAuthFieldActive: true })}
                  onBlur={() => this.setState({ isAuthFieldActive: false })}
                />
              </div>
            </div>
          }
        />

        <CustomizedSnackbar
          isOpen={this.state.isOpenSnackbar}
          message={this.state.snackbarMessage}
          severity={this.state.snackbarSeverity}
          handleCloseSnackbar={() => this.handleSnackbar(false, "", "")}
          autoHideDuration={3000}
        />
      </Fragment>
    );
  }
}

C09DispatchDashboard.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(useStyles)(C09DispatchDashboard);
